"use strict";

exports.__esModule = true;

exports.default = function (innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/helpers/newArrowCheck.js
// module id = 589
// module chunks = 2